// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-table-1 {
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
  border-collapse: collapse;
}
.custom-table-1 th {
  font-weight: 700;
  padding: 4px 10px;
  height: 30px;
  font-size: 1.2em;
  border: 0;
}
.custom-table-1 td {
  font-size: 0.8125rem;
  height: 36px;
  padding: 0 10px;
}
.custom-table-1 td > svg {
  fill: currentColor;
  cursor: pointer;
}
@media (min-width: 767px) {
  .custom-table-1 td > svg {
    opacity: 0;
  }
}
.custom-table-1 tr:hover > td > svg {
  opacity: 1;
}
.custom-table-1 tr:hover > td > svg:hover {
  fill: currentColor;
}

.sensors-rows ~ .sensors-rows {
  border-top: 1px solid rgba(0, 0, 0, 0.1254901961);
  margin-top: 4px;
}

.stepper .step-label.step-label-completed:not(.Mui-error),
.stepper .step-label.step-label-active:not(.Mui-error),
.stepper .step-label:not(.Mui-error) {
  color: inherit;
}
.stepper .MuiStepContent-root {
  margin-left: 0;
  border-left-width: 0;
  padding-left: 0;
}
.stepper .step-connector {
  margin-left: 0;
}
.stepper .step-connector .MuiStepConnector-lineVertical {
  border-left-width: 0;
}

.stepper-wrapper .stepper {
  background: none;
  color: inherit;
  padding: 0;
}

.step-label-root svg {
  display: block;
}

.text-warning {
  color: #ffc107;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Units/Style.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AAAJ;AACI;EACI,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;AACR;AACI;EACI,oBAAA;EAEA,YAAA;EACA,eAAA;AAAR;AACQ;EACI,kBAAA;EACA,eAAA;AACZ;AAAY;EAHJ;IAIQ,UAAA;EAGd;AACF;AAEQ;EACI,UAAA;AAAZ;AACY;EACI,kBAAA;AAChB;;AAMI;EACI,iDAAA;EACA,eAAA;AAHR;;AAYQ;;;EACI,cAAA;AAPZ;AAUI;EACI,cAAA;EACA,oBAAA;EACA,eAAA;AARR;AAUI;EACI,cAAA;AARR;AASQ;EACI,oBAAA;AAPZ;;AAWA;EACI,gBAAA;EACA,cAAA;EACA,UAAA;AARJ;;AAWA;EACI,cAAA;AARJ;;AAWA;EACI,cCrBU;ADad","sourcesContent":["@import \"./../../assets/variables.scss\";\n.custom-table-1 {\n    width: 100%;\n    text-align: left;\n    margin-bottom: 10px;\n    border-collapse: collapse;\n    th {\n        font-weight: 700;\n        padding: 4px 10px;\n        height: 30px;\n        font-size: 1.2em;\n        border: 0;\n    }\n    td {\n        font-size: 0.8125rem;\n        //background: #fafafa;\n        height: 36px;\n        padding: 0 10px;\n        > svg {\n            fill: currentColor;\n            cursor: pointer;\n            @media (min-width: 767px) {\n                opacity: 0;\n            }\n        }\n    }\n    tr {\n        \n        &:hover > td > svg {\n            opacity: 1;\n            &:hover {\n                fill: currentColor;\n            }\n        }\n    }\n}\n\n.sensors-rows {\n    & ~ & {\n        border-top: 1px solid #00000020;\n        margin-top: 4px;\n    }\n    \n}\n\n.stepper {\n    .step-label.step-label-completed,\n    .step-label.step-label-active,\n    .step-label {\n        &:not(.Mui-error) {\n            color: inherit;\n        }\n    }\n    .MuiStepContent-root {\n        margin-left: 0;\n        border-left-width: 0;\n        padding-left: 0;\n    }\n    .step-connector {\n        margin-left: 0;\n        .MuiStepConnector-lineVertical {\n            border-left-width: 0;\n        }\n    }\n}\n.stepper-wrapper .stepper {\n    background: none;\n    color: inherit;\n    padding: 0;\n}\n\n.step-label-root svg {\n    display: block;\n}\n\n.text-warning {\n    color: $warning\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$sidebarWidth : 320px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 50px;\n$headerNavWidth: 50px;\n$headerNavWidthExpended: 200px;\n$headerHeight: 50px;\n$footerHeight: 0;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 3px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: #B2B5C4;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #e0e0e0;\n$lightGrey: #d7d7d7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 1;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 14px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Poppins, sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
